<template>
  <div class="message-wrap">
    <div class="bg">
      <p class="title">
        {{ store.state.alertShowInfo.title }}
      </p>
      <p class="content">
        {{ store.state.alertShowInfo.content }}
      </p>
      <div class="btn-list">
        <div class="btn" v-if="store.state.alertShowInfo.isChancelShow" @click="cancel">
          {{ $t("取消") }}
        </div>
        <div class="btn" @click="check">
          {{ $t("确认") }}
        </div>
      </div>
      <img src="../../assets/img/icons/icon-close.png" alt="" class="close" @click="store.commit('closeAlert')">
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';

const store = useStore();

/**
 * 点击确认按钮
 */
function check() {
  if (store.state.alertShowInfo.callback) {
    store.state.alertShowInfo.callback();
  }
  store.commit('closeAlert');
}

/**
 * 点击取消按钮
 */
function cancel() {
  if (store.state.alertShowInfo.cancelCallback) {
    store.state.alertShowInfo.cancelCallback();
  }
  store.commit('closeAlert');
}

</script>

<style lang="less" scoped>
.message-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .5);
  z-index: 1000;

  .bg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 52.70833vw;
    box-sizing: border-box;
    padding: 2.8125vw 3.33333vw 2.60416vw;
    background: #fff;
    border-radius: 0.83333vw;
    background: linear-gradient(to bottom, rgba(180, 29, 35, .15), #fff) no-repeat;
    background-size: 100% 7.8125vw;
    background-color: #fff;

    .title {
      font-size: 1.66666vw;
      line-height: 2.34375vw;
      color: #B41D23;
      text-align: center;
      margin-bottom: 2.60416vw;
    }

    .content {
      font-size: 0.9375vw;
      line-height: 1.25vw;
      color: #171A41;
      margin-bottom: 3.33333vw;
    }

    .btn-list {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .btn {
        width: 5.625vw;
        box-sizing: border-box;
        font-size: 0.83333vw;
        line-height: 2.39583vw;
        color: #B41D23;
        text-align: center;
        border: 0.05208vw solid #B41D23;
        border-radius: 0.41666vw;
        cursor: pointer;

        &:last-child {
          color: #fff;
          background: #B41D23;
          border: none;
          margin-left: 1.25vw;
        }
      }
    }

    .close {
      position: absolute;
      top: 2.5vw;
      right: 2.5vw;
      width: 1.66666vw;
      cursor: pointer;
    }
  }
}

@media screen and (max-width: 750px) {

  .message-wrap {

    .bg {
      width: 89.86666vw;
      padding: 6.13333vw 5.33333vw 6.4vw;
      background-size: 100% 18vw;
      border-radius: 1.6vw;

      .title {
        font-size: 4.26666vw;
        line-height: 6.13333vw;
        margin-bottom: 11.2vw;
      }

      .content {
        font-size: 3.73333vw;
        line-height: 5.33333vw;
      }

      .btn-list {

        .btn {
          width: 18.13333vw;
          font-size: 3.73333vw;
          line-height: 8.26666vw;
          border: 0.13333vw solid #B41D23;
          border-radius: 1.06666vw;

          &:last-child {
            line-height: 8.53333vw;
            margin-left: 3.2vw;
          }
        }
      }

      .close {
        top: 6.4vw;
        right: 5.33333vw;
        width: 6.4vw;
      }
    }
  }

}
</style>
